import { createContext } from "react";

const AuthContext = createContext<AuthValue>({
    state: "initializing",
    userId: undefined,
    isLoggedIn: false,
    onLogin: async () => {},
    onLogout: async () => {},
});

export default AuthContext;
